import { render, staticRenderFns } from "./CartBillingAddress.vue?vue&type=template&id=52237f8b&"
import script from "./CartBillingAddress.vue?vue&type=script&lang=ts&"
export * from "./CartBillingAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports